export const skillList = [
  {
    name: "React",
    imgUrl: "https://i.ibb.co/jWGhYqM/react-icon.png",
  },
  {
    name: "JavaScript",
    imgUrl: "https://i.ibb.co/zGbPy2k/Java-Script-logo.png",
  },
  {
    name: "NodeJs",
    imgUrl: "https://i.ibb.co/5rMPyZZ/nodejs-logo.png",
  },
  {
    name: "React Native",
    imgUrl: "https://i.ibb.co/jWGhYqM/react-icon.png",
  },
  {
    name: "Mongo DB",
    imgUrl: "https://i.ibb.co/zRfdQM3/mongodb-pngrepo-com.png",
  },
  {
    name: "Redux",
    imgUrl: "https://i.ibb.co/x1c0LgD/redux-icon.png",
  },
  {
    name: "Firebase",
    imgUrl: "https://i.ibb.co/W6Nn6d2/firebase-icon.png",
  },
  {
    name: "MySql",
    imgUrl: "https://i.ibb.co/tMYgM81/mysql.png",
  },
  {
    name: "Typescript ",
    imgUrl: "https://i.ibb.co/x27f04g/ts-icon.png",
  },
  {
    name: "CoffeeScript ",
    imgUrl: "https://i.ibb.co/WW2DmTw/coffeescript-icon.webp",
  },
  {
    name: "Polymer",
    imgUrl: "https://i.ibb.co/TqkNfgF/polymerjs.png",
  },
  {
    name: "Figma",
    imgUrl: "https://i.ibb.co/qNkRDc6/figma.png",
  },
];
